<template>
  <v-container fluid pt-0>
    <v-row align="center" class="pb-2">
      <h1 class="headline">GT AI Demo</h1>
      <v-spacer></v-spacer>
    </v-row>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col>
            <v-textarea
              label="Prompt"
              v-model="prompt"
              :outlined="outlinedInputs"
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-select
              v-model="context"
              :items="contextOptions"
              label="Context"
              :outlined="outlinedInputs"
            >
            </v-select>
          </v-col>
          <v-col>
            <v-text-field
              label="Count"
              v-model="count"
              :outlined="outlinedInputs"
              type="number"
            >
            </v-text-field
          ></v-col>
        </v-row>
        <v-divider></v-divider>
        <v-container>
          <v-row align="center" justify="center">
            <v-btn
              @click="onGenerate"
              color="primary"
              :loading="$apollo.loading"
              >Generate</v-btn
            >
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <v-row v-if="resultItems.length > 0">
      <v-col>
        <v-card v-for="(item, index) in resultItems" :key="index" class="mt-2">
          <v-card-title>
            <h3 class="headline">{{ item.metadata.name }}</h3>
          </v-card-title>
          <v-card-subtitle>
            <p><strong>Score:</strong>{{ item.score }}</p></v-card-subtitle
          >
          <v-card-text>
            <p>{{ item.pageContent }}</p>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="primary" @click="onDetails(item)"
              >View Details <v-icon small right>mdi-open-in-new</v-icon></v-btn
            ></v-card-actions
          >
        </v-card>
      </v-col>
    </v-row>
    <code>
      {{ resultItems }}
    </code>

    <v-row
      ><v-col
        ><code>{{ result }}</code></v-col
      ></v-row
    >
  </v-container>
</template>

<script>
import gql from "graphql-tag";
const GT_AI_QUERY = gql`
  query gtAiQuer($prompt: String!, $count: Int!, $context: String) {
    gtAIQuery(prompt: $prompt, count: $count, context: $context) {
      success
      error
      message
      data
    }
  }
`;
export default {
  name: "GtAI",
  data() {
    return {
      prompt: "Nice hotel near the beach",
      context: "supplier",
      contextOptions: [
        { text: "Supplier", value: "supplier" },
        { text: "Itinerary", value: "itinerary" },
      ],
      count: 5,
      skipLoad: true,
      result: {},
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    resultItems() {
      if (this.result.data) {
        const dataItems = JSON.parse(this.result.data);
        return dataItems.map((itemArr) => {
          return {
            ...itemArr[0],
            score: itemArr[1],
          };
        });
      } else {
        return [];
      }
    },
  },

  methods: {
    onGenerate() {
      this.skipLoad = false;
    },
    onDetails(item) {
      console.log(item);
      const routeData = this.$router.resolve({
        path: `${this.context}/${item.metadata.id}/details`,
      });
      window.open(routeData.href, "_blank");
    },
  },

  apollo: {
    gtAIQuery: {
      query: GT_AI_QUERY,
      variables() {
        return {
          prompt: this.prompt,
          count: Number(this.count),
          context: this.context,
        };
      },
      skip() {
        return this.skipLoad;
      },
      result({ data, error }) {
        this.skipLoad = true;
        if (error) {
          this.result = { error: error.message };
        } else {
          this.result = data.gtAIQuery;
        }
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/plugins/gt-ai/GtAI.vue